import React from "react";

function WidgetsButton({ title, Icon, RemoveImage }) {
  return (
    <button className="widgetsButton" onClick={RemoveImage}>
      {Icon && <Icon />}
      {title}
    </button>
  );
}

export default WidgetsButton;
